// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GXxp","newExpiryDate":"styles_newExpiryDate__3sK55","footer":"styles_footer__RSha-"};